import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Typography, Box, Divider, Grid } from '@mui/material'
import SimpleMaterialsTable from 'components/generic/printable/table/SimpleMaterialsTable'
import ReceiptGridMetaInfo from 'components/generic/printable/components/ReceiptGridMetaInfo'

const PrintableScaleFull = ({ printInboundTicketData, pricePrepend, ticketCreator }) => {
  const { customer, effectiveDate, transportationInfo, materials, address, carrierName, notes, truckWeight } =
    printInboundTicketData
  const { enablePrintedDocCompliance, useMinimalObt } = useSelector(state => state.featureFlags?.variables || {})

  const { settings } = useSelector(state => state.settings)
  const { includeOperatorLastName } = settings?.documentSettings?.general || {}

  const formattedMaterials = useMemo(
    () =>
      materials
        ?.map(material => ({
          ...material,
          materialName: material?.overrideName || material?.materialName || material?.materialType?.commonName,
          overrideName: '',
        }))
        ?.sort((a, b) => {
          if (!a.rowIndex) return 1
          if (!b.rowIndex) return -1
          return a.rowIndex - b.rowIndex
        }) || [],
    [materials],
  )
  return (
    <>
      <ReceiptGridMetaInfo
        dispatchTicket={printInboundTicketData?.linkedDispatchTicket?.externalId}
        customer={customer}
        ticketCreator={ticketCreator}
        carrierName={carrierName}
        effectiveDate={effectiveDate}
        transportationInfo={transportationInfo}
        notes={notes}
        type="PRINT_SCALE_TICKET"
        inboundTicketAddress={address}
      />
      <Grid sx={useMinimalObt ? { flex: 1, border: '1px solid black', borderTop: '0px', padding: 1 } : {}} container>
        {useMinimalObt ? (
          <Grid item xs={12}>
            <strong>Order Information</strong>
          </Grid>
        ) : (
          <Typography mt={3} variant="body1">
            Materials
          </Typography>
        )}
        <SimpleMaterialsTable
          materials={formattedMaterials}
          truckWeight={truckWeight}
          type="PRINT_SCALE_TICKET"
          showMaterialDeductionNotes
          isPrint
          pricePrepend={pricePrepend}
        />
      </Grid>

      {useMinimalObt ? (
        <>
          <Grid container sx={{ border: '1px solid black', borderTop: '0px', padding: 1 }}>
            <Grid item xs={12}>
              <strong>WeighMaster</strong>
              <Typography variant="body2">{`${ticketCreator.firstName}${includeOperatorLastName ? ` ${ticketCreator.lastName}` : ''}`}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} py={1} pl={2} sx={{ border: '1px solid black', borderTop: '0px', padding: 1 }}>
              <strong>Disclaimer</strong>
              <Typography variant="body2" fontSize=".6rem">
                {settings?.documentSettings?.general?.scaleTicketDisclaimer || ''}
              </Typography>
            </Grid>
          </Grid>
        </>
      ) : (
        <div id="disclaimer">
          <Box mt={5} borderBottom="1px">
            <Typography variant="body1">Accepted [ &nbsp;&nbsp;&nbsp;&nbsp; ]</Typography>
            <Divider sx={{ width: '100%' }} />
          </Box>

          <Box mt={2}>
            <Typography variant="body1">Disclaimer</Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: '8px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              {settings?.documentSettings?.general?.scaleTicketDisclaimer || ''}
            </Typography>
          </Box>
          <Box mt={2} sx={{ borderBottom: '1px dotted lightgray' }} />
        </div>
      )}

      {enablePrintedDocCompliance && !useMinimalObt && (
        <div id="weighmaster-certificate">
          <Box mt={2}>
            <Typography variant="body1">WEIGHMASTER CERTIFICATE</Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: '8px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              {settings?.documentSettings?.general?.weighmasterCertificate || ''}
            </Typography>
          </Box>
          <Box mt={2} sx={{ borderBottom: '1px dotted lightgray' }} />
        </div>
      )}
    </>
  )
}

PrintableScaleFull.propTypes = {
  printInboundTicketData: PropTypes.object.isRequired,
  pricePrepend: PropTypes.string,
  ticketCreator: PropTypes.object.isRequired,
}

PrintableScaleFull.defaultProps = {
  pricePrepend: '$',
}

export default PrintableScaleFull
